<script setup>
import BreezeButton from '@/Components/Button.vue';
//import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';

const form = useForm({
    name: '',
    user: '',
    email: '',
    password: '',
    password_confirmation: '',
    terms: false,
});

const submit = () => {
    form.post(route('register'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>

<template>
    <BreezeAuthenticatedLayout>
        <Head title="Register" />

        <BreezeValidationErrors class="mb-4" />

        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Añadir estudiante o prospecto<!-- In basebutton: @click="route('dashboard')"-->
            </h2>   
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <form @submit.prevent="submit">
                            <div>
                                <BreezeLabel for="name" value="Apellidos" />
                                <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autofocus autocomplete="name" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="user" value="Nombres" />
                                <BreezeInput id="user" type="text" class="mt-1 block w-full" v-model="form.user" required autocomplete="user" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="email" value="Distrito" />
                                <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="username" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password" value="Referencia de domicilio" />
                                <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password_confirmation" value="Fecha de nacimiento" />
                                <BreezeInput id="password_confirmation" type="date" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password_confirmation" value="Distrito de nacimiento" />
                                <BreezeInput id="password_confirmation" type="text" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password_confirmation" value="Colegio de procedencia" />
                                <BreezeInput id="password_confirmation" type="text" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password_confirmation" value="Distrito de Colegio de procedencia" />
                                <BreezeInput id="password_confirmation" type="text" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password_confirmation" value="Religión" />
                                <BreezeInput id="password_confirmation" type="text" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                            </div>

                            <div class="mt-4">
                                <BreezeLabel for="password_confirmation" value="Será exonerado de religión?" />
                                <BreezeInput id="password_confirmation" type="text" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                            </div>

                            <div class="flex items-center justify-end mt-4">
                                <!--<Link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                    Already registered?
                                </Link>-->

                                <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Aceptar
                                </BreezeButton>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
